import { Link, useParams } from 'react-router-dom';
import { useApiQuery } from '../use-api.js';
import type { TranscriptResponse, TranscriptEvent } from '../lib/types.js';

function EventRow({ ev }: { ev: TranscriptEvent }) {
  if (ev.type === 'assistant_text') return <div className="tl-assistant">{ev.text}</div>;
  if (ev.type === 'tool_use')
    return <div className="tl-tool">🔧 <strong>{ev.tool}</strong>: <code>{ev.summary}</code></div>;
  if (ev.type === 'tool_result')
    return <div className={ev.is_error ? 'tl-result-err' : 'tl-result'}>→ {ev.summary}</div>;
  if (ev.type === 'result')
    return (
      <div className="tl-final">
        result: {ev.subtype} · {ev.num_turns ?? '—'} turns
        {ev.total_cost_usd != null ? ` · $${ev.total_cost_usd.toFixed(2)}` : ''}
      </div>
    );
  return null; // system/other: not shown
}

export function RunTranscript() {
  const { id = '' } = useParams();
  const query = useApiQuery<TranscriptResponse>(['transcript', id], `/api/runs/${encodeURIComponent(id)}/transcript`);

  return (
    <section>
      <div className="detail-head">
        <h2>Transcript — {id}</h2>
        <Link className="btn-link" to={`/runs/${encodeURIComponent(id)}`}>← Back to run</Link>
      </div>

      {query.isLoading && <p>Loading transcript…</p>}
      {query.isError && <p className="error">Failed to load transcript.</p>}
      {!query.isLoading && !query.isError && query.data && (
        query.data.available ? (
          <>
            {query.data.truncated && <p className="muted">Transcript truncated for display.</p>}
            <div className="timeline">
              {query.data.events.map((ev) => <EventRow key={ev.seq} ev={ev} />)}
            </div>
          </>
        ) : (
          <p className="empty">Transcript available after the run finishes.</p>
        )
      )}
    </section>
  );
}
